module.exports = __webpack_public_path__ + "img/ma.a2e6a76e.svg";